var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2584 8.5L15.5 2.28868C15.1906 2.11004 14.8094 2.11004 14.5 2.28868L3.7417 8.5M26.2584 8.5V20.9226C26.2584 21.2799 26.0678 21.61 25.7584 21.7887L15 28M26.2584 8.5L15 14.5M15 28L4.2417 21.7887C3.9323 21.61 3.7417 21.2799 3.7417 20.9226V8.5M15 28V14.5M3.7417 8.5L15 14.5",
    stroke: "#FF6700",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeton);
export default __webpack_public_path__ + "static/media/beton.8baaab9f29ccbdef7bea50e1e1138531.svg";
export { ForwardRef as ReactComponent };